"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Telegram = function Telegram(props) {
	return _react2.default.createElement(
		"svg",
		_extends({}, props, { viewBox: "0 0 48 48" }),
		_react2.default.createElement("path", { d: "M41.23 8.61a1.87 1.87 0 0 0-1.34-.126c-.144.048-1.544.583-3.113 1.188s-4.98 1.918-7.586 2.92l-9.24 3.55c-2.476.95-6.317 2.426-8.53 3.277s-4.15 1.612-4.308 1.69c-1.1.553-1.453 1.232-.943 1.793a1.99 1.99 0 0 0 .533.387c.17.078 2.192.724 4.493 1.436s4.2 1.308 4.21 1.326.738 2.345 1.6 5.17c1.033 3.375 1.616 5.182 1.7 5.263a1.515 1.515 0 0 0 1.123.18c.667-.11.433.086 3.805-3.185a9.087 9.087 0 0 1 1.592-1.414c.04.032 1.488 1.1 3.22 2.368l4.136 3.04a3.96 3.96 0 0 0 2.107 1.04 1.583 1.583 0 0 0 1.6-1.228c.087-.25 4.552-21.04 5.573-25.95.298-1.428.095-2.3-.632-2.725z" })
	);
};

exports.default = Telegram;


//////////////////
// WEBPACK FOOTER
// ./~/react-share-icons/lib/Telegram/index.js
// module id = 176
// module chunks = 0